import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import "@/assets/css/icon-moon.css";
import { useSettingsStore } from "@/stores";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  // Uygulama başladığında ayarları yükle (logo, favicon vs.)
  const settingsStore = useSettingsStore();
  settingsStore.fetchSettings();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})